module.exports = __webpack_public_path__ + "img/meeting.aa34ea21.svg";